import clsx from "clsx";

interface ISegmentedControl<T> {
  label: string;
  options: { label: string; value: T }[];
  value: T;
  onChange: (value: T) => void;
}

const SegmentedControl = <T extends string>({
  label,
  options,
  value,
  onChange,
}: ISegmentedControl<T>) => (
  <div className="flex items-center gap-3 smallTablet:w-full smallTablet:justify-between">
    <span className="text-[11px] font-semibold uppercase tracking-wider text-light-gray whitespace-nowrap">
      {label}
    </span>
    <div
      role="radiogroup"
      aria-label={label}
      className="flex items-center p-1 rounded-lg bg-input-bg"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={value === option.value}
          onClick={() => onChange(option.value)}
          className={clsx(
            "h-7 px-3 rounded-md text-[13px] font-medium whitespace-nowrap transition-all duration-200",
            value === option.value
              ? "bg-surface text-text-primary shadow-card"
              : "text-light-gray hover:text-text-primary"
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  </div>
);

export default SegmentedControl;
